import React from 'react';
// Context
import { useAppState } from 'context/AppContext';
// Elements
import Notification from 'elements/Notification';
// Style
import styles from './style/notifications.module.css';

interface NotificationProps {
  id: string,
  label: string,
  type: string,
}

function Notifications() {
  const { notifications } = useAppState();
  function renderNotification(notification:NotificationProps) {
    const { id, label, type } = notification;
    return (
      <Notification
        id={id}
        key={id}
        label={label}
        type={type}
      />
    )
  }

  return (
    <div className={styles.container}>
      {notifications.map(renderNotification)}
    </div>
  );
}

export default Notifications;